import { IonText } from '@ionic/react';
import { IconComponent } from '../../theme/Icons';
import { IThemeColor } from '../../theme/IThemeColor';
import { createUseStyles } from 'react-jss';
import { ICheckinTag } from '../model/ICheckin';

const useStyles = createUseStyles({
    container: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
    },

    icon: {
        padding: 8,
        marginBottom: 2,
        textAlign: 'center',
        borderRadius: '50%'
    }
});

export interface ICheckinIconProps {
    Icon: IconComponent;
    iconSize?: 'small' | 'medium' | 'large';
    label?: ICheckinTag;
    active?: boolean;
    activeColor?: IThemeColor;
    'data-type'?: string;
    'data-id'?: string;
    onClick?: () => void;
};

export const CheckinIcon: React.FC<ICheckinIconProps> = ({ Icon, iconSize = 'large', active, activeColor, label, 'data-type': dataType, 'data-id': dataId, onClick }) => {
    const classes = useStyles();
    const color = active ? activeColor : 'medium';
    const backgroundColor = active ? `rgb(var(--ion-color-${activeColor}-rgb), 0.1)` : 'var(--ion-color-light)';

    const iconWidths = { small: 33, medium: 37, large: 45 };

    return (
        <div
            data-type={dataType}
            data-id={dataId}
            data-active={active}
            onClick={onClick}
            className={classes.container}
            style={{cursor: onClick ? 'pointer' : undefined}}
        >
            <div className={classes.icon} style={{backgroundColor: backgroundColor, minWidth: iconWidths[iconSize]}}>
                <Icon color={color} size={iconSize} />
            </div>

            {label &&
                <IonText color="medium"><small><b>{label}</b></small></IonText>
            }
        </div>
    );
};
